import React from 'react';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';

export function BlogPosts(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};

  const posts = getPages(cmsUtils.payload(item, 'BlogPosts'));
  const numOfTileLines = parseInt(cmsUtils.payload(item, 'NumOfTileLines', '2'));
  //console.log(posts);
  const bp = utils.ui.getCurrentBreakpoint();
  const tilesPerLine = {xs:1, sm:1, md:2, lg:2, xl:3, xxl:4}
  //const numOfPost = numOfTileLines * (tilesPerLine[bp] || 3);
  const numOfPost = numOfTileLines * (tilesPerLine[bp] || 12);
  const step = numOfPost;

  const [tilesToShow, setTilesToShow] = React.useState(numOfPost);

  const displayingPosts = posts.length > tilesToShow ? posts.slice(0, tilesToShow) : posts;
  const showMore = posts.length > displayingPosts.length;

  const pageTileElts = displayingPosts.map((page, index) =>
    <Tile2 page={page} key={index} disableLink={cmsOption.isCmsEdit}></Tile2>
  );

  const cssClass = utils.classNames('cms_item', 'blogTiles pageTiles tiles', item.cssClass || item.anchorName || '');

  return (
    <>
      <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
        {pageTileElts}
      </div>
      {showMore && (<div className="blogTiles__loadMore">
        <span className="thinBtn" onClick={(e) => { setTilesToShow(tilesToShow + step) }}>LOAD MORE</span></div>)}
    </>
  );
}

function getPages(pagesSerialized) {
  if (pagesSerialized) {
    return JSON.parse(pagesSerialized);
  }
  return [];
}

// function Tile(props) {
//   const page = props.page;
//   const imageUrl = utils.site.resourcePath(page.imageUrl);
//   const disableLink = props.disableLink;
//   return (
//     <div className="blogTile">
//       <SiteLink className="blogTile__link" to={disableLink ? '' : page.pageUrl}>
//         <div className="blogTile__bg" style={{ backgroundImage: utils.css.bgUrlStyle(imageUrl) }}></div>
//         <div className="blogTile__content">
//           <div className="blogTile__contentInner">
//             <div className="blogTile__title">
//               {page.pageTitle}
//             </div>
//             <div className="blogTile__desc">
//               {page.tileDesc || page.description}
//             </div>
//             <div className="blogTile__readMore thinBtn">READ MORE</div>
//           </div>
//         </div>
//       </SiteLink>
//     </div>
//   )
// }

function Tile2(props) {

  const page = props.page;
  const imageUrl = utils.site.resourcePath(page.imageUrl);
  const disableLink = props.disableLink;
  // const _date = utils.date.formatDDMMYYYY(page.postDate);

  return (
    <div className="pageTile tile blog">
      <SiteLink className="pageTile__content tile__content" to={disableLink ? '' : page.pageUrl}>
        <div className="tile__bg" style={{ backgroundImage: utils.css.bgUrlStyle(imageUrl) }}></div>
        <div className="pageTile_details tile__details">
          {/* <div className="pageTile__date">
            {_date}
          </div> */}
          <div className="pageTile__title">
            {page.pageTitle}
          </div>
          <hr className='pageTile__line' />
          <div className="pageTile_desc">
            {page.tileDesc || page.description}
          </div>
        </div>
      </SiteLink>
    </div>
  )
}